import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'

export interface Rout_EventRoutesArgs {
    PlannerApp: React.FunctionComponent<unknown>
}

export const Rout_EventRoutes = (args: Rout_EventRoutesArgs) => [
    Rout_create('/plannerEvent/:page/:eventId', args.PlannerApp),
]

export function Rout_toEventEdit(eventId: string | number) {
    Rout_to(`/plannerEvent/event/${eventId}`)
}
